import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useRouteMatch } from "react-router-dom";

import { useRecoilState, useRecoilValueLoadable } from 'recoil'
import { visitorState } from '../../recoil/atoms/visitorAtom'
import { visitorQueryByToken } from '../../recoil/selectors/visitorSelectors'

import Box from '../../components/Box/Box'
import Button from '../../components/UI/Button/Button';



const Welcome = React.memo((props) => {
    const [visitor, setVisitor] = useRecoilState(visitorState);

    const match = useRouteMatch("/invitation/:slug");
    let slug = null
    try {
        slug = match.params.slug
    } catch {
        slug = null
    }
    const visitorLoadable = useRecoilValueLoadable(visitorQueryByToken(slug));

    useEffect(
        () => {
            if(slug){
                setVisitor({ id: visitorLoadable.contents.id, name: visitorLoadable.contents.name, company: visitorLoadable.contents.company, email: visitorLoadable.contents.email })
            }
            
        },
        [slug, visitorLoadable, setVisitor]
    )
    return (
        <div style={{ marginTop: 5 + 'em' }}>

            <Box>

            Hello {visitor.name}{visitor.company ? ` from ${visitor.company}` : ''},<br/>
            after your long journey<br/>
            through the Ether space<br/>
            I want to welcome<br /><br/>
            YOU.<br /><br/>
            My name is Jakob.


            </Box>
            <Box>

                Can I serve you coffee or tea with the cookies?<br /><br />

                <Link to="/serve/coffee"><Button clicked={() => { }}>Coffee</Button></Link>
                <Link to="/serve/tea"><Button>Tea</Button></Link>

            </Box>

        </div>
    )
})


export default Welcome